const affDomains = {
  "betway178.biz": "B129129", //測試用
  "vndbetway.com": "B123540",
  "vietnambetway.com": "B123541",
  "bway227.com": "B123952",
  "bw1230.com": "B120003",
  "bw1886.com": "B123586",
  "bongbway88.com": "B123954",
  "tiyubaba.com": "B120001",
  "bw0880.com": "B120002",
  "bw0883.com": "B123585",
  "bw88dj.com": "B129013",
  "bwvip365.com": "B129129",
  "biwei365vip.com": "B129144",
  "bwayvip365.com": "B129145",
  "bwsvip365.com": "B129160",
}

export default affDomains;
